<script setup lang="ts">import { ref as _ref, toRef as _toRef, computed as _computed } from 'vue';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { useElementSize } from '@vueuse/core'

withDefaults(defineProps<{
  startOpen?: boolean
  forceOpen?: boolean
  closeLabel?: string
  openLabel?: string
  displayBefore?: boolean
}>(), { closeLabel: 'Hide Details',openLabel: 'View Details', })

const expanded = _ref(__props.startOpen)

const toggleButton = ref<HTMLElement>()
const __$temp_1 = (useElementSize(toggleButton)),
  buttonWidth = _toRef(__$temp_1, 'width');
const narrow = _computed(() => buttonWidth.value < 400)
</script>

<template>
  <template v-if="forceOpen">
    <slot/>
  </template>
  <template v-else>
    <TransitionExpand v-if="displayBefore">
      <slot v-if="expanded"/>
    </TransitionExpand>

    <GButton
      ref="toggleButton"
      v-bind="$attrs"
      flat
      primary
      class="g-details-toggle"
      :style="narrow ? { justifyContent: 'space-between' } : { justifyContent: 'start' }"
      :label="expanded ? closeLabel : openLabel"
      :iconRight="expanded ? faChevronUp : faChevronDown"
      @click="expanded = !expanded"
    />

    <TransitionExpand v-if="!displayBefore">
      <slot v-if="expanded"/>
    </TransitionExpand>
  </template>
</template>
